<template>
  <div class="closing" v-loading="loading">
    <div class="section">
      <div class="section-title">成交转化漏斗（近30天）</div>
      <el-row :gutter="16">
        <el-col :span="8" v-for="item in funnelCards" :key="item.label">
          <div class="stat-card">
            <div class="label">{{ item.label }}</div>
            <div class="value">{{ item.value }}</div>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-alert
      title="商品访问 Top、预计成交率客户排行可继续对接小程序成交率接口，当前先展示转化漏斗总览。"
      type="info"
      :closable="false"
      show-icon
    />
  </div>
</template>

<script>
import { getChangeCount } from '@/api/radar'

export default {
  name: 'ClosingRate',
  data() {
    return {
      loading: false,
      funnel: {}
    }
  },
  computed: {
    funnelCards() {
      const f = this.funnel || {}
      return [
        { label: '访问商品', value: f.seeGoodsNum || f.visitGoods || 0 },
        { label: '下单', value: f.orderNum || f.createOrder || 0 },
        { label: '支付', value: f.payNum || f.payOrder || 0 }
      ]
    }
  },
  created() {
    this.load()
  },
  methods: {
    async load() {
      this.loading = true
      try {
        const res = await getChangeCount({ type: 2, dayNum: 30 })
        this.funnel = (res && res.data) || {}
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.section { margin-bottom: 24px; }
.section-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 12px;
}
.stat-card {
  background: #f7fafa;
  border-radius: 8px;
  padding: 16px 20px;
  .label { color: #8a8f93; font-size: 13px; }
  .value { color: #51cbcd; font-size: 28px; font-weight: 700; margin-top: 8px; }
}
</style>
